import React from 'react'
import { SubheadingContainer } from './PrimaryNavigationExterior'
import { fontSize2XSmall, fontWeightBold } from '../../../constants/principles'
import styled from '@emotion/styled'
import IconSvgs from '../IconSvgs'

const PrimaryNavigationMechanical = ({ conditionQuestions, props }) => {
  const svgIcons = ['Engine', 'Transmission', 'Steering', 'Exhaust', 'Suspension', 'Heating/ Air Conditioning', 'Battery/ Electrical', 'Stereo', 'Odometer', 'Sunroof/ Moonroof', 'Airbags', 'Frame/ Structural']

  return (
    <StyledContainer>
      <IconSvgs {...{ titleOverride: 'I have mechanical issues with...', conditionQuestions, svgIcons, ...props }} />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  button {
    flex-direction: column;
    align-items: center;
    width: 130px;
  }
  h1 {
    font-size: 14px;
  }
`

export default PrimaryNavigationMechanical
